import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, shareReplay, Subject, switchMap, take, tap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BannerFilter } from '@shared/entities/bannerFilter';
import { BannerFilterURL } from './banner.service';

const LOG_PREFIX = '[Api][BannerFilters] ';

@Injectable({
  providedIn: 'root'
})
export class BannerFiltersService extends ApiService<BannerFilter> {
  private _refresh$: Subject<boolean>;
  all$: Observable<BannerFilter>;

  set filters(value: BannerFilterURL) {
    this.refresh(true);
  }

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/banners/filters';
    const detailUrl = '/banners/filters';

    super(BannerFilter, masterUrl, detailUrl);

    this._refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this._refresh$.pipe(
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }
        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this._refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
